import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  mainTabContainer: {
    marginTop: theme.spacing(-2),
  },
  description: {
    marginTop: theme.spacing(-4),
  },
  awsImage: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  cloudImage: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
  cloudContent: {
    padding: theme.spacing(4, 0),
  },
  inputWrapper: {
    display: 'flex',
    padding: theme.spacing(1, 0),
    gap: theme.spacing(2),
    alignItems: 'flex-start',
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2.5),
  },
  input: {
    width: '100%',
  },
  chipList: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    margin: theme.spacing(3, 0),
  },
  chip: {
    display: 'flex',
    height: theme.spacing(4),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.select.main,
    padding: `${theme.spacing(0.75, 1, 0.75, 2)} !important`,
    gap: theme.spacing(1),
    border: 'none',
    '& .MuiChip-label': {
      textAlign: 'center',
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: theme.palette.labraText.tertiary,
      padding: theme.spacing(0),
    },
    '& .MuiChip-deleteIcon': {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25),
      color: theme.palette.textField.light,
    },
  },
  competitorDescription: {
    marginTop: theme.spacing(-3),
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.textField.main,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
  fetchAndSave: {
    padding: `${theme.spacing(0.75, 3)} !important`,
    height: theme.spacing(7),
  },
}))
